import * as React from 'react';
import classnames from 'classnames';
import isNil from 'lodash/isNil';

import './table-cell.scss';

import type { TableAlign, TableWidth } from 'types';

type Props = {
  width?: TableWidth,
  align?: TableAlign,
  fontSize?: 'small' | 'normal',
  verticalAlign?: 'start' | 'end',
  padding?: 'none' | 'normal',
  overflow?: 'hidden',
  children: React.ReactNode,
  customModifier?: string,
  className?: string
};

class TableCell extends React.PureComponent<Props> {
  static defaultProps = {
    align: 'left',
    width: 'auto',
    padding: 'normal'
  };

  render(): React.ReactNode {
    const {
      width,
      align,
      fontSize,
      padding,
      children,
      verticalAlign,
      overflow,
      customModifier,
      className
    } = this.props;

    const classes = classnames('table-cell', className, {
      [`table-cell--overflow-${overflow}`]: overflow,
      [`table-cell--width-${width}`]: width,
      [`table-cell--align-${align}`]: align,
      [`table-cell--font-size-${fontSize}`]: fontSize,
      [`table-cell--padding-${padding}`]: padding,
      [`table-cell--vertical-align-${verticalAlign}`]: verticalAlign,
      [`table-cell--${customModifier ?? ''}`]: !isNil(customModifier)
    });

    return (
      <div className={classes}>
        {children}
      </div>
    );
  }
}

export default TableCell;
